const BROWSER_EXTENSION_PROTOCOL = /^(?:chrome|moz|safari-web|safari)-extension:\/\//;
const BROWSER_EXTENSION_PROTOCOL_ANYWHERE = /(?:chrome|moz|safari-web|safari)-extension:\/\//;

// Browser extensions inject scripts served from *-extension:// URLs. Errors they throw
// bubble to our global handler but aren't ours to fix, so we skip reporting them.
export const isBrowserExtensionError = (filename?: string | null) => BROWSER_EXTENSION_PROTOCOL.test(filename ?? '');

// Unhandled promise rejections don't carry a filename, so the extension protocol is matched
// anywhere in the reason's stack trace instead of anchored at the start.
export const isBrowserExtensionRejection = (reason: unknown) =>
  reason instanceof Error && BROWSER_EXTENSION_PROTOCOL_ANYWHERE.test(reason.stack ?? '');
